import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const CanonicalUrl = ({ title, description, type = 'website' }) => {
  const location = useLocation();
  
  // Base canonical domain - always use https://www.botimza.com (with www)
  const baseUrl = 'https://www.botimza.com';
  
  // Get clean pathname without query parameters
  const cleanPath = location.pathname;
  
  // Search-result URLs (/?q=...) are infinite, thin variants of the same SPA shell. They must not
  // be indexed, and must not each declare themselves canonical (Google then reports "duplicate
  // without user-selected canonical"). Canonical stays the clean path; the page is noindex.
  const hasSearchQuery = new URLSearchParams(location.search).has('q');
  const canonicalUrl = `${baseUrl}${cleanPath}`;
  
  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
      {hasSearchQuery && <meta name="robots" content="noindex, follow" />}
      <meta property="og:url" content={canonicalUrl} />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content={type} />
    </Helmet>
  );
};

export default CanonicalUrl; 